jQuery(document).ready(function ($) {
  function scrollToSection(sectionElement) {
    if (!sectionElement || !sectionElement.length) {
      return;
    }
    var headerHeight = $('.header').outerHeight();
    setTimeout(() => {
      window.scrollTo({
        top: $(sectionElement).offset().top - headerHeight,
        behavior: 'smooth',
      });
    }, 100);
  }

  $(window).on('load', function () {
    if (window.location.hash) {
      scrollToSection($(window.location.hash));
    }
  });

  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();

      scrollToSection(this.getAttribute('href'));
    });
  });

  // new WOW().init({
  //   callback: function (box) {
  //   },
  // });

  if ($('.hop__logo').length) {
    $('.hop__logo').slick({
      arrows: false,
      dots: false,
      centerMode: true,
      centerPadding: '40px',
      slidesToShow: 6,
      autoplay: true,
      autoplaySpeed: 1000,
      pauseOnFocus: false,
      pauseOnHover: false,
      infinite: true,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    });
    $('.hop__logo li div').matchHeight();
  }

  function hsListController(containerId) {
    if ($(containerId).length) {
      $(containerId)
        .find('.hs__item__title')
        .on('click', function () {
          const newImg = $(this).closest('.hs__item').data('img');
          const currentImg = $(containerId)
            .find('.hs__imgs__main img')
            .attr('src');

          $(containerId)
            .find('.hs__imgs__sub img')
            .each(function () {
              const imgSrc = $(this).attr('src');

              if (imgSrc === newImg) {
                $(this).attr('src', currentImg);
              }
            });
          $(containerId).find('.hs__imgs__main img').attr('src', newImg);

          $(containerId).find('.hs__item').removeClass('act');
          $(containerId)
            .find('.hs__item')
            .find('.hs__item__content')
            .stop()
            .slideUp();
          $(this).closest('.hs__item').addClass('act');
          $(this)
            .closest('.hs__item')
            .find('.hs__item__content')
            .stop()
            .slideDown();
        });
    }
  }

  hsListController('.hs__list1');
  hsListController('.hs__list2');
  hsListController('.hs__list3');
  hsListController('.hs__list4');

  $('.header__toggle').on('click', function () {
    $(this).toggleClass('act');
    if ($('.header__dropdown').hasClass('act')) {
      $('.header__dropdown').stop().slideUp(200).removeClass('act');
    } else {
      $('.header__dropdown').stop().slideDown(200).addClass('act');
    }
  });

  if ($(window).width() <= 1024) {
    $('.hs__item__title').matchHeight();
  }
  $(window).on('resize', function () {
    if ($(window).width() <= 1024) {
      $('.hs__item__title').matchHeight();
    }
  });

  if ($('.hct__right__slider').length) {
    $('.hct__right__slider').slick({
      arrows: false,
      dots: false,
      slidesToShow: 1,
      autoplay: true,
      autoplaySpeed: 1000,
      pauseOnFocus: false,
      pauseOnHover: false,
      infinite: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }
  // $('.hct__section').matchHeight();

  if ($('.popup__bg').length) {
    $('.header').addClass('blur');
    $('.footer').addClass('blur');
    $('.main').addClass('blur');
    $('body').addClass('noScroll');
    $('.popup__bg').addClass('act');

    $('.popup__item__local').on('click', function () {
      $('.header').removeClass('blur');
      $('.footer').removeClass('blur');
      $('.main').removeClass('blur');
      $('body').removeClass('noScroll');
      $('.popup__bg').removeClass('act');
    });

    if ($(window).width() <= 768) {
      var bgMobile = $('.popup__modal').data('bgmobile');
      if (bgMobile) {
        $('.popup__modal').css('background-image', 'url(' + bgMobile + ')');
      }
    }
  }

  $(window).on('scroll', function () {
    if ($(window).scrollTop() > 300) {
      $('.go2top').addClass('act');
    } else {
      $('.go2top').removeClass('act');
    }
  });
  $('.go2top').on('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return false;
  });
});
